import { useState, useEffect, useCallback } from 'react'

const useElementWidth = elementRef => {
  const [elementWidth, setElementWidth] = useState(0)

  const updateElementWidth = useCallback(() => {
    if (elementRef.current) {
      setElementWidth(elementRef.current.getBoundingClientRect().width)
    }
  }, [elementRef])

  useEffect(() => {
    updateElementWidth()
    window.addEventListener('resize', updateElementWidth)

    return () => {
      window.removeEventListener('resize', updateElementWidth)
    }
  }, [elementRef, updateElementWidth])

  return elementWidth
}

export default useElementWidth
